const results = [
  {
    icon: 'ri-speed-up-line',
    title: 'Быстрая адаптация',
    desc: 'Новички выходят на плановые KPI в 2-3 раза быстрее. Среднее время — 2-3 месяца вместо 6-12. Каждый месяц «недоадаптации» — это упущенная прибыль компании.',
  },
  {
    icon: 'ri-user-smile-line',
    title: 'Снижение текучести',
    desc: 'Процент уволившихся на испытательном сроке падает до 5-10%. Компания перестаёт терять деньги на рекрутинг и повторный найм.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Быстрый выход на продажи',
    desc: 'Менеджеры по продажам начинают приносить выручку уже на 3-4 неделе вместо 2-3 месяцев. В масштабах отдела — это миллионы дополнительной прибыли.',
  },
  {
    icon: 'ri-fire-line',
    title: 'Рост вовлечённости',
    desc: 'Сотрудники, прошедшие качественный онбординг, вовлечены на 30-40% выше среднего по компании. Они становятся движущей силой, а не пассивными исполнителями.',
  },
  {
    icon: 'ri-team-line',
    title: 'Лучше корпоративная культура',
    desc: 'Единая система адаптации формирует общие ценности и стандарты. Новички быстрее становятся «своими» и транслируют культуру дальше.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Больше инициативы',
    desc: 'Адаптированные сотрудники не боятся предлагать улучшения. Они знают процессы и видят, что можно оптимизировать — свежий взгляд без страха.',
  },
  {
    icon: 'ri-arrow-down-circle-line',
    title: 'Снижение нагрузки на руководителя',
    desc: 'Руководитель тратит на 40-60% меньше времени на исправление ошибок новичков и разбор «пожаров». Освобождается время на стратегические задачи.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Рост эффективности бизнеса',
    desc: 'Суммарный эффект: ниже текучесть, быстрее выход на KPI, выше вовлечённость, меньше ошибок. Всё это напрямую влияет на прибыль компании.',
  },
];

export default function CompanyResults() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Какие результаты получает компания
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Системная адаптация персонала — это не расходы, а инвестиции. Вот восемь измеримых результатов, которые получают компании после внедрения программы онбординга.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {results.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-6 border border-gray-100 hover:shadow-md transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}